/*
 * @Author: AllezLRC 13636411941@163.com
 * @Date: 2022-03-11 14:30:38
 * @LastEditors: AllezLRC 13636411941@163.com
 * @LastEditTime: 2025-03-20 14:07:48
 * @FilePath: /wemeet-admin-new/src/vab/plugins/permissions.js
 * @Description:
 * Copyright (c) 2025 by WeMeet, All Rights Reserved.
 */
/**
 * @description 路由守卫，目前两种模式：all模式与intelligence模式
 */
import store from '@/store'
import router from '@/router'
import VabProgress from 'nprogress'
import 'nprogress/nprogress.css'
import getPageTitle from '@/utils/pageTitle'
import { toLoginRoute } from '@/utils/routes'
import { authentication, loginInterception, routesWhiteList, supportVisit } from '@/config'
import { isIllegalAccessLocation } from '@/utils/accessGuard'

export function setup() {
  VabProgress.configure({
    easing: 'ease',
    speed: 500,
    trickleSpeed: 200,
    showSpinner: false,
  })
  router.beforeEach(async (to, from, next) => {
    const { showProgressBar } = store.getters['settings/theme']
    if (showProgressBar) VabProgress.start()

    if (isIllegalAccessLocation() && (to.path !== '/403' || to.query.type !== 'illegalAccess')) {
      next({ path: '/403', query: { type: 'illegalAccess' }, replace: true })
      if (showProgressBar) VabProgress.done()
      return
    }

    let hasToken = store.getters['user/token']

    if (!loginInterception) hasToken = true

    if (hasToken) {
      if (store.getters['routes/routes'].length) {
        // 禁止已登录用户返回登录页
        if (to.path === '/login') {
          next({ path: '/' })
          if (showProgressBar) VabProgress.done()
        } else next()
      } else {
        try {
          if (loginInterception) await store.dispatch('user/getUserInfo')
          // config/setting.config.js loginInterception为false(关闭登录拦截时)时，创建虚拟角色
          else await store.dispatch('user/setVirtualRoles')
          // 根据路由模式获取路由并根据权限过滤
          await store.dispatch('routes/setRoutes', authentication)
          next({ ...to, replace: true })
        } catch (err) {
          console.error('vue-admin-beautiful错误拦截:', err)
          await store.dispatch('user/resetAll')
          next(toLoginRoute(to.fullPath))
        }
      }
    } else {
      if (routesWhiteList.includes(to.path)) {
        // 设置游客路由(不需要可以删除)
        if (supportVisit && !store.getters['routes/routes'].length) {
          await store.dispatch('routes/setRoutes', 'visit')
          next({ path: to.path, replace: true })
        } else next()
      } else next(toLoginRoute(to.fullPath))
    }
  })
  router.afterEach((to) => {
    document.title = getPageTitle(to.meta.title)
    if (VabProgress.status) VabProgress.done()
  })
}
